import {axiosInstance as http} from '@/http_client';

// Session-cached review-state probe for the nav badge — SidePanelNav remounts
// on every page, so cache the promise rather than refetching each navigation.
let promise = null;

export function getActivityStatus() {
    if (!promise) {
        const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
        promise = http.get('app/study-activity/status', {params: {tz}})
            .then(r => r.data)
            .catch(() => {
                promise = null; // allow retry on next mount after a failure
                return {state: 'normal'};
            });
    }
    return promise;
}
